import { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Loader2, ShieldAlert } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";

const destino = (rol) => (rol === "tutor" ? "/portal" : rol === "docente" ? "/docente"
  : rol === "coordinadora" ? "/coordinacion" : "/admin");

export default function GoogleCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { loginGoogle, config } = useAuth();
  const [error, setError] = useState("");
  const procesado = useRef(false);

  useEffect(() => {
    if (procesado.current) return;
    procesado.current = true;
    const sessionId = new URLSearchParams(location.hash.replace(/^#/, "")).get("session_id");
    if (!sessionId) {
      setError("No recibimos la sesión de Google. Vuelva a intentar el acceso.");
      return;
    }
    (async () => {
      const res = await loginGoogle(sessionId);
      if (!res.ok) {
        setError(res.error);
        return;
      }
      navigate(destino(res.user.rol), { replace: true });
    })();
  }, [location.hash, loginGoogle, navigate]);

  return (
    <div className="grid min-h-screen place-items-center bg-background p-6" data-testid="google-callback">
      {error ? (
        <div className="w-full max-w-md rounded-lg border border-destructive/30 bg-destructive/5 p-8 text-center">
          <ShieldAlert className="mx-auto h-9 w-9 text-destructive" />
          <h1 className="mt-5 font-display text-2xl font-extrabold tracking-tight">
            No pudimos iniciar su sesión
          </h1>
          <p className="mt-4 text-sm leading-relaxed text-muted-foreground" data-testid="google-error">
            {error}
          </p>
          <div className="mt-8 flex flex-wrap justify-center gap-3">
            <Button asChild className="rounded-full">
              <Link to="/login" data-testid="google-volver-login">Volver al inicio de sesión</Link>
            </Button>
            <Button asChild variant="outline" className="rounded-full">
              <Link to="/registro" data-testid="google-solicitar-acceso">Solicitar acceso</Link>
            </Button>
          </div>
        </div>
      ) : (
        <div className="text-center" data-testid="google-procesando">
          <Loader2 className="mx-auto h-8 w-8 animate-spin text-primary" />
          <p className="mt-5 font-display text-lg font-bold">Validando su cuenta de Google…</p>
          <p className="mt-2 text-sm text-muted-foreground">{config.nombre}</p>
        </div>
      )}
    </div>
  );
}
